module.exports = __webpack_public_path__ + "img/category_30.6ff4a1b8.png";